import { Card, CardContent, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '@/utils/formatters';

interface ReceivablesSummaryProps {
  /** Sum of what customers still owe the branch (TL). */
  totalOutstanding: number;
  /** Number of receivables that are not settled yet (open or partial). */
  openCount: number;
}

const ReceivablesSummary = ({
  totalOutstanding,
  openCount
}: ReceivablesSummaryProps) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <Card>
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary">
              {t('receivables.summary.totalOutstanding')}
            </Typography>
            <Typography
              variant="h3"
              component="p"
              color="warning.main"
              data-testid="receivables-total-outstanding"
            >
              {formatCurrency(Number(totalOutstanding) || 0)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Card>
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary">
              {t('receivables.summary.openCount')}
            </Typography>
            <Typography
              variant="h3"
              component="p"
              data-testid="receivables-open-count"
            >
              {openCount}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {t('receivables.summary.openCount.hint')}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ReceivablesSummary;
